import { reactive } from 'vue';

interface UsageLimitModalOptions {
    title?: string;
    description?: string;
    list?: string[];
    buttonText?: string;
    upgradeUrl?: string;
    customUpgradeJump?: boolean;
    onUpgrade?: (url: string) => void;
}

const usageLimitModalState = reactive({
    visible: false,
    title: '',
    description: '',
    list: undefined as string[] | undefined,
    buttonText: undefined as string | undefined,
    upgradeUrl: undefined as string | undefined,
    customUpgradeJump: false,
    onUpgrade: undefined as ((url: string) => void) | undefined,
});

function openUsageLimitModal(options: UsageLimitModalOptions = {}) {
    usageLimitModalState.title = options.title ?? '';
    usageLimitModalState.description = options.description ?? '';
    usageLimitModalState.list = options.list;
    usageLimitModalState.buttonText = options.buttonText;
    usageLimitModalState.upgradeUrl = options.upgradeUrl;
    usageLimitModalState.customUpgradeJump = options.customUpgradeJump ?? false;
    usageLimitModalState.onUpgrade = options.onUpgrade;
    usageLimitModalState.visible = true;

    console.debug('[UsageLimitModal] Opened:', {
        hasCustomTitle: !!options.title,
        hasCustomDescription: !!options.description,
        listCount: options.list?.length ?? 0,
        upgradeUrl: options.upgradeUrl,
    });
}

function closeUsageLimitModal() {
    usageLimitModalState.visible = false;
    usageLimitModalState.customUpgradeJump = false;
    usageLimitModalState.onUpgrade = undefined;
}

function useUsageLimitModal() {
    return {
        usageLimitModalState,
        openUsageLimitModal,
        closeUsageLimitModal,
    };
}

export {
    useUsageLimitModal,
    openUsageLimitModal,
    closeUsageLimitModal,
};

export type { UsageLimitModalOptions };
